import React from 'react';
import RouteMapItems from '../RouteMapItems/RouteMapItems';
import { useRoutesWithoutTaskMapItems } from './hooks/useRoutesWithoutTaskMapItems';

interface IProps {}

const RoutesWithoutTaskMapItems = (props: IProps) => {
  const {
    checkedRoutes,
    onFieldClick,
    checkedRouteIds,
    routeFields,
  } = useRoutesWithoutTaskMapItems();

  return (
    <RouteMapItems
      routes={checkedRoutes}
      onFieldClick={onFieldClick}
      checkedRouteIds={checkedRouteIds}
      routeFields={routeFields}
    />
  );
};

export default RoutesWithoutTaskMapItems;
